import {useMemo} from 'react';
import {Platform, useWindowDimensions} from 'react-native';

/**
 * Custom hook for responsive dimensions that respects web max-width constraints
 * On web, constrains content to a maximum width while maintaining full screen height
 * @param maxWidth - Maximum width on web (default: 512px)
 * @returns {width, height} - Responsive dimensions
 */
export const useResponsiveDimensions = (maxWidth: number = 480) => {
  const {width: windowWidth, height: windowHeight} = useWindowDimensions();

  const width = useMemo(() => {
    return Platform.OS === 'web' ? Math.min(windowWidth, maxWidth) : windowWidth;
  }, [windowWidth, maxWidth]);

  return {
    width,
    height: windowHeight,
  };
};

export default useResponsiveDimensions;
